module.exports = __webpack_public_path__ + "img/lady-bug.59b13865.png";